export default __webpack_public_path__ + "static/media/Table_pot.539128c1.webp";